"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.comparePropsDev = exports.compareProps = void 0;
exports.useLogPropsChanges = useLogPropsChanges;
var _react = require("react");
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function useLogPropsChanges(props) {
  var propsRef = (0, _react.useRef)({});
  _toConsumableArray(new Set([].concat(_toConsumableArray(Object.keys(props)), _toConsumableArray(Object.keys(propsRef.current))))).forEach(function (k) {
    if (propsRef.current[k] !== props[k]) {
      console.log('change prop', k);
    }
  });
  propsRef.current = props;
  console.log('useLogPropsChanges', props);
}
var compareProps = exports.compareProps = function compareProps(prevProps, nextProps) {
  return !Object.keys(_objectSpread(_objectSpread({}, prevProps), nextProps)).some(function (key) {
    return prevProps[key] !== nextProps[key] && !(0, _isEqual["default"])(prevProps, nextProps);
  });
};
var comparePropsDev = exports.comparePropsDev = function comparePropsDev(prevProps, nextProps) {
  var changedProps = {};

  // Сравниваем ключи
  Object.keys(_objectSpread(_objectSpread({}, prevProps), nextProps)).forEach(function (key) {
    if (prevProps[key] !== nextProps[key]) {
      if (!(0, _isEqual["default"])(prevProps, nextProps)) {
        changedProps[key] = {
          prev: prevProps[key],
          next: nextProps[key]
        };
      }
    }
  });
  if (Object.keys(changedProps).length > 0) {
    console.log('[React.memo] Changed props:', changedProps);
  }

  // Если никаких изменений, вернуть true, чтобы избежать ререндера
  return Object.keys(changedProps).length === 0;
};